<!-- Body -->
<ui-dialog
    [open]="isDeleteJobPostingDialogOpen"
    (closing)="closeDeleteJobPostingDialog()"
    header="{{ 'applicant-tracker.deleteDraft' | translate }}"
    size="small"
>
    <p>{{ 'applicant-tracker.messages.jobPosting.areYouSureYouWantToDeleteDraft' | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteJobPostingDialog()">{{
            'applicant-tracker.cancel' | translate
        }}</ui-button>
        <ui-button type="danger" (click)="onDelete()">{{ 'applicant-tracker.delete' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header [title]="'applicant-tracker.jobPostings'" [menuService]="recruitingModuleMenuService">
        <div class="buttons">
            <ui-button
                type="primary"
                (click)="trackJobPostingCreation()"
                [routerLink]="['/recruiting', 'jobPostings', 'create']"
                *ngIf="canCreateJobPosting"
                [disabled]="jobBoardNotConfigured"
            >
                <mat-icon aria-hidden="true" svgIcon="plus"></mat-icon>
                {{ 'applicant-tracker.createJobPosting' | translate }}
            </ui-button>
        </div>
    </app-header>
    <ui-banner *ngIf="jobBoardNotConfigured && !table.isEmpty" variant="danger" class="margin-bottom-4">
        <p [innerHTML]="'applicant-tracker.messages.jobBoardNeedsToBeSetup' | translate"></p>
    </ui-banner>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            [table]="table"
            [isResponsive]="true"
            (menuItemSelected)="menuAction($event)"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <div class="empty">
                <ng-container *ngIf="!jobBoardNotConfigured">
                    <app-empty-state
                        label="{{
                            !table.hasFiltersApplied()
                                ? 'applicant-tracker.messages.jobPosting.noJobPostingsAtThisTime'
                                : 'applicant-tracker.messages.jobPosting.noJobPostingsFoundForFilter'
                        }}"
                        src="/assets/illustrations/briefcase.png"
                    >
                    </app-empty-state>
                </ng-container>

                <ng-container *ngIf="jobBoardNotConfigured">
                    <app-empty-state
                        label="{{
                            !table.hasFiltersApplied()
                                ? 'applicant-tracker.messages.jobPosting.noJobPostings'
                                : 'applicant-tracker.messages.jobPosting.noJobPostingsFoundForFilter'
                        }}"
                        src="/assets/illustrations/briefcase.png"
                    >
                    </app-empty-state>

                    <div class="centered margin-bottom-3 font-medium">
                        <a class="ui centered" [routerLink]="['/recruiting/settings/jobBoard']" target="_blank">
                            {{ 'applicant-tracker.setupJobBoard' | translate }}
                        </a>
                    </div>
                </ng-container>
            </div>
        </app-table>
    </ui-card>
</div>
